/**
 *
 * Toggle Button
 *
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2019-03-05
 *
 */


document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.stile .button');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		return next.classList.contains('frame');
	}

	function setEventListener(btn) {
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		next.style.display = 'none';
		next.classList.add('hidden');
		setTimeout(() => { next.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		if (visible) {
			next.classList.remove('hidden');
		} else {
			next.classList.add('hidden');
		}
	}

});
